import { render } from "./Maintenance.vue?vue&type=template&id=5bb15a98&scoped=true"
import script from "./Maintenance.vue?vue&type=script&lang=js"
export * from "./Maintenance.vue?vue&type=script&lang=js"

import "./Maintenance.vue?vue&type=style&index=0&id=5bb15a98&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bb15a98"]])

export default __exports__